import React from 'react';

import {isObject, isResponseErrorWithCode} from '~shared/utils';
import {TransformedResponseError, UpdateErrors} from '~shared/models';

import {IS_INTERNAL} from '~ui/constants';
import {ContainsSecretMessage} from '~ui/components/ContainsSecretMessage';

export const getContainsSecretMessage = (error: TransformedResponseError<string[]>) => {
    if (!IS_INTERNAL) {
        return '';
    }

    return <ContainsSecretMessage error={error} />;
};

export const isContainsSecretError = (val: unknown): val is TransformedResponseError<string[]> => {
    return isResponseErrorWithCode(val, UpdateErrors.ContainsSecret) && isObject(val.details.data);
};
